export default __webpack_public_path__ + "static/media/blob2.78d89bda.svg";